import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import AppointmentForm from "./AppointmentForm";

export default function CTASection() {
  return (
    <section className="py-24 bg-slate-50 relative overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-10 right-10 w-72 h-72 bg-teal-100 rounded-full blur-3xl opacity-50" />
        <div className="absolute bottom-10 left-10 w-96 h-96 bg-orange-100 rounded-full blur-3xl opacity-40" />
      </div>

      <div className="container-max relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-white border border-slate-200 rounded-full px-4 py-1.5 mb-6 shadow-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-teal-600" />
              <span className="text-xs font-semibold text-teal-700 uppercase tracking-wider">Primera visita gratuita</span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              Da el primer paso. <span className="underline-accent">Sin coste</span>, sin compromiso.
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Revisamos tu caso, te hacemos un diagnóstico completo con TAC 3D si es necesario
              y te proponemos el tratamiento ideal. Tú decides, siempre.
            </p>
            <ul className="space-y-3 mb-8">
              {[
                "Diagnóstico profesional sin coste",
                "Plan de tratamiento personalizado",
                "Presupuesto transparente, sin sorpresas",
                "Financiación hasta 60 meses sin intereses",
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-slate-700">
                  <div className="w-6 h-6 rounded-full bg-teal-50 border border-teal-200 flex items-center justify-center shrink-0">
                    <Check className="w-3.5 h-3.5 text-teal-700" strokeWidth={3} />
                  </div>
                  {item}
                </li>
              ))}
            </ul>
            <Link
              to="/contacto"
              data-testid="cta-contact-link"
              className="inline-flex items-center gap-2 text-teal-700 hover:text-teal-900 font-semibold hover:gap-3 transition-all"
            >
              O contáctanos directamente
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl border border-slate-100">
            <h3 className="text-2xl font-bold text-slate-900 mb-2">Reserva online</h3>
            <p className="text-slate-600 text-sm mb-6">Te contactaremos en menos de 24h</p>
            <AppointmentForm variant="light" />
          </div>
        </div>
      </div>
    </section>
  );
}
